import React from "react";
import useMeta from '../../../hooks/useMeta';

import "./Product_OS_UI.css";
import { Product_OS_Data } from "../Product_OS_Data";

import Navbar from "../../../CommonComponent/Navbar/Navbar";
import NotificationBar from "../../../CommonComponent/Notification/NotificationBar";
import Footer from "../../../CommonComponent/Footer/footer";

import { useParams, Link } from "react-router-dom";

const Product_OS_UI = () => {
    const { ProductOS_PG_ID } = useParams();
    const Current_OS_PG = Product_OS_Data[ProductOS_PG_ID];

    const META_PG_OG_Title = Current_OS_PG?.META_PG_OG_Title || '';
    const META_PG_OG_Description = Current_OS_PG?.META_PG_OG_Description || 'Discover premium window treatments at Callistus Blinds. Explore our extensive range of stylish blinds and shades to enhance your home’s aesthetic and comfort.';
    const META_PG_Canonical_OG_URL = Current_OS_PG?.META_PG_Canonical_OG_URL || '';

    useMeta({
        title: `${META_PG_OG_Title}`,
        description: `${META_PG_OG_Description}`,
        canonical: `${META_PG_Canonical_OG_URL}`,
        og: {
            locale: 'en_US',
            type: 'article',
            title: `${META_PG_OG_Title}`,
            description: `${META_PG_OG_Description}`,
            url: `${META_PG_Canonical_OG_URL}`,
            site_name: 'Callistus Blinds',
        },
    });

    if (!Current_OS_PG) {
        return (
            <>
                <Navbar />
                <NotificationBar />
                <div className="product-os-container">
                    <h1>Error 404: Page Not Found</h1>
                </div>
                <Footer />
            </>
        );
    }

    const {
        Product_OS_TITLE,
        Product_OS_VID_Embed_Link,
        Product_OS_Sub_TITLE,
        Product_OS_DECRIPTION
    } = Current_OS_PG;

    return (
        <>
            <Navbar />
            <NotificationBar />
            <div className="product-os-container">
                {Product_OS_TITLE && (
                    <h2 className="product-os-title">{Product_OS_TITLE}</h2>
                )}

                {Product_OS_VID_Embed_Link && (
                    <div className="product-os-video-wrapper">
                        <iframe
                            src={Product_OS_VID_Embed_Link}
                            title={Product_OS_TITLE}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    </div>
                )}

                {(Product_OS_Sub_TITLE || Product_OS_DECRIPTION) && (
                    <div className="product-os-details">
                        <p className="product-os-overview">Overview</p>
                        {Product_OS_Sub_TITLE && (
                            <h3 className="product-os-feature-title">{Product_OS_Sub_TITLE}</h3>
                        )}
                        {Product_OS_DECRIPTION && (
                            <p className="product-os-description">{Product_OS_DECRIPTION}</p>
                        )}
                        <Link to="/operating-systems" className="product-os-btn">
                            FIND OUT MORE
                        </Link>
                    </div>
                )}
            </div>
            <Footer />
        </>
    );
};

export default Product_OS_UI;
